/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMileageRate.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/mileage-rate";

export class AutogenModelMileageRate<RowType extends ModelRow> extends Endpoint<RowType, RowMileageRateFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMileageRate extends ModelRow<RowMileageRateFields> {
	constructor(values?: Partial<RowMileageRateFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMileageRateFields {
	column_number: number;
	company_id: string;
	rate_value: string;
	row_number: number;
	table_id: string;
}

